/* tslint:disable */
/* eslint-disable */
/**
 * Smart Central - FDC
 * Smart Central - FDC API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { OperationalEnrolment } from '../models';
/**
 * EnrolmentApi - axios parameter creator
 * @export
 */
export const EnrolmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all enrolled children
         * @param {number} orgId Organisation ID
         * @param {number} srvId Service ID
         * @param {string} date Date today
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperationalEnrolments: async (orgId: number, srvId: number, date: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('getOperationalEnrolments', 'orgId', orgId)
            // verify required parameter 'srvId' is not null or undefined
            assertParamExists('getOperationalEnrolments', 'srvId', srvId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getOperationalEnrolments', 'date', date)
            const localVarPath = `/organisation/{org_id}/service/operational_enrolments/{srv_id}.json`
                .replace(`{${"org_id"}}`, encodeURIComponent(String(orgId)))
                .replace(`{${"srv_id"}}`, encodeURIComponent(String(srvId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnrolmentApi - functional programming interface
 * @export
 */
export const EnrolmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnrolmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all enrolled children
         * @param {number} orgId Organisation ID
         * @param {number} srvId Service ID
         * @param {string} date Date today
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperationalEnrolments(orgId: number, srvId: number, date: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OperationalEnrolment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperationalEnrolments(orgId, srvId, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EnrolmentApi - factory interface
 * @export
 */
export const EnrolmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnrolmentApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all enrolled children
         * @param {number} orgId Organisation ID
         * @param {number} srvId Service ID
         * @param {string} date Date today
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperationalEnrolments(orgId: number, srvId: number, date: string, options?: any): AxiosPromise<Array<OperationalEnrolment>> {
            return localVarFp.getOperationalEnrolments(orgId, srvId, date, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnrolmentApi - object-oriented interface
 * @export
 * @class EnrolmentApi
 * @extends {BaseAPI}
 */
export class EnrolmentApi extends BaseAPI {
    /**
     * 
     * @summary Get all enrolled children
     * @param {number} orgId Organisation ID
     * @param {number} srvId Service ID
     * @param {string} date Date today
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrolmentApi
     */
    public getOperationalEnrolments(orgId: number, srvId: number, date: string, options?: AxiosRequestConfig) {
        return EnrolmentApiFp(this.configuration).getOperationalEnrolments(orgId, srvId, date, options).then((request) => request(this.axios, this.basePath));
    }
}
